export class Params {
  public static USER_DATA={
    uid: "",
    name: "",
    email: "",
    photo: "",
    roles : []
  };

  public static toDate(date){
    return new Date(date).toLocaleString("es-CL")
  }

  public static REQUEST_TYPES = {
    "CP" : "Cambio de Plan",
    "CF" : "Cambio de Comidas",
    "CA" : "Cambio de dirección de despacho",
    "CD" : "Cambio días de despacho",
    "CR" : "Cambio restricciones",
    "CC" : "Cambio condiciones",
    "RE" : "Reingreso",
    "CI1" : "Inactivación por no pago",
    "CI2" : "Inactivación por no renovación"
  }

  public static OUT_TYPES = [
    {
      code : "VA",
      name : "Vacaciones"
    },
    {
      code : "RE",
      name : "Problema con restricciones"
    },
    {
      code : "LO",
      name : "Problema con despacho"
    },
    {
      code : "ME",
      name : "Le aburrió el menú"
    },
    {
      code : "PR",
      name : "Muy costoso"
    },
    {
      code : "CO",
      name : "Probará otra empresa"
    },
    {
      code : "OT",
      name : "Otro"
    }
  ]

  public static money(val){
    if(val){
      let value = Math.trunc(val);
      return "$"+value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    }else{
      return "$0";
    }
  }

  public static prodType(type){
    const types = [
      {name : 'Compuesto', value: 'CO'},
      {name : 'Único porción fija', value: 'UNF'},
      {name : 'Único porción variable', value: 'UNV'},
      {name : 'Único externo', value: 'UNE'}
    ];
    const f = types.filter((x)=>x.value===type);
    if(f.length>0) {
      return f[0].name;
    }else{
      return "N/D"
    }
  }

  public static restrictionType(type){
    const types = [
      {name : 'Ingrediente', value: 1},
      {name : 'Grupo de ingredientes', value: 2},
      {name : 'Receta', value: 3},
      {name : 'Grupo de recetas', value: 4}
    ];
    const f = types.filter((x)=>x.value===type);
    if(f.length>0) {
      return f[0].name;
    }else{
      return "N/D"
    }
  }

  public static solveRestrictionType(type){
    const types = [
      {name : 'Reemplazar Receta', value: 1},
      {name : 'Quitar ingrediente', value: 2}
    ];
    const f = types.filter((x)=>x.value===type);
    if(f.length>0) {
      return f[0].name;
    }else{
      return "N/D"
    }
  }

  public static disc(price, discount){
    let p = Number(price);
    if( discount ){
      let d = Number(discount);
      p = p * (100-d)/100
      p = Math.round(p / 10 )*10;
    }
    return p;
  }


  public static dayPrice(c,foods,format){
    let total = 0;
    if(c.foods && foods){
      for(let i=0;i<c.foods.length;i++){
        total = total + Number(foods[c.foods[i]].prize);
      }
    }

    if(c.delivery){
      if(c.delivery==1) total = total + 700;
      if(c.delivery==2) total = total + 600;
      if(c.delivery==3) total = total + 500;
      if(c.delivery==4) total = total + 300;
      if(c.delivery==6) total = total + 400;
      if(c.delivery==7) total = total + 500;
      if(c.delivery==8) total = total + 600;
    }

    if(c.discount){
      let n = (total*c.discount)/100;
      total = total - n;
    }

    if(c.aditional_cost){
      total = total + Number(c.aditional_cost);
    }
    total = Math.round(total);

    if(format) {
      return Params.money(total);
    }else{
      return total;
    }
  }

  public static key_parse(k){
    if(k){
      let a = String(k);
      let b = a.replace(/[^a-z0-9]/gi,'');
      let c = b.toUpperCase();
      return c;
    }
  }


  public static generate_guide_code(name,lastname){
    let key = "";
    if(name!="" && lastname!=""){
      key = this.key_parse(name).substr(0,3) + '_' +this.key_parse(lastname);
    }
    return key;
  }

  public static number_two_digits(n){
    let ns = String(n);
    if(ns.length==1){
      ns = "0"+ns;
    }
    return ns;

  }

  public static parse_xls(s){
    if(s){
      let ret = s;
      ret = ret.replace(/á/gi,"a");
      ret = ret.replace(/é/gi,"e");
      ret = ret.replace(/í/gi,"i");
      ret = ret.replace(/ó/gi,"o");
      ret = ret.replace(/ú/gi,"u");
      ret = ret.replace(/ñ/gi,"n");
      ret = ret.replace(/\;/g,' ');
      return ret;
    } else {
      return "";
    }
  }

  public static md5(string){

    function RotateLeft(lValue, iShiftBits) {
      return (lValue << iShiftBits) | (lValue >>> (32 - iShiftBits));
    }

    function AddUnsigned(lX, lY) {
      let lX4, lY4, lX8, lY8, lResult;
      lX8 = (lX & 0x80000000);
      lY8 = (lY & 0x80000000);
      lX4 = (lX & 0x40000000);
      lY4 = (lY & 0x40000000);
      lResult = (lX & 0x3FFFFFFF) + (lY & 0x3FFFFFFF);
      if (lX4 & lY4) {
        return (lResult ^ 0x80000000 ^ lX8 ^ lY8);
      }
      if (lX4 | lY4) {
        if (lResult & 0x40000000) {
          return (lResult ^ 0xC0000000 ^ lX8 ^ lY8);
        } else {
          return (lResult ^ 0x40000000 ^ lX8 ^ lY8);
        }
      } else {
        return (lResult ^ lX8 ^ lY8);
      }
    }

    function F(x, y, z) {
      return (x & y) | ((~x) & z);
    }

    function G(x, y, z) {
      return (x & z) | (y & (~z));
    }

    function H(x, y, z) {
      return (x ^ y ^ z);
    }

    function I(x, y, z) {
      return (y ^ (x | (~z)));
    }

    function FF(a, b, c, d, x, s, ac) {
      a = AddUnsigned(a, AddUnsigned(AddUnsigned(F(b, c, d), x), ac));
      return AddUnsigned(RotateLeft(a, s), b);
    };

    function GG(a, b, c, d, x, s, ac) {
      a = AddUnsigned(a, AddUnsigned(AddUnsigned(G(b, c, d), x), ac));
      return AddUnsigned(RotateLeft(a, s), b);
    };

    function HH(a, b, c, d, x, s, ac) {
      a = AddUnsigned(a, AddUnsigned(AddUnsigned(H(b, c, d), x), ac));
      return AddUnsigned(RotateLeft(a, s), b);
    };

    function II(a, b, c, d, x, s, ac) {
      a = AddUnsigned(a, AddUnsigned(AddUnsigned(I(b, c, d), x), ac));
      return AddUnsigned(RotateLeft(a, s), b);
    };

    function ConvertToWordArray(string) {
      let lWordCount;
      let lMessageLength = string.length;
      let lNumberOfWords_temp1 = lMessageLength + 8;
      let lNumberOfWords_temp2 = (lNumberOfWords_temp1 - (lNumberOfWords_temp1 % 64)) / 64;
      let lNumberOfWords = (lNumberOfWords_temp2 + 1) * 16;
      let lWordArray = Array(lNumberOfWords - 1);
      let lBytePosition = 0;
      let lByteCount = 0;
      while (lByteCount < lMessageLength) {
        lWordCount = (lByteCount - (lByteCount % 4)) / 4;
        lBytePosition = (lByteCount % 4) * 8;
        lWordArray[lWordCount] = (lWordArray[lWordCount] | (string.charCodeAt(lByteCount) << lBytePosition));
        lByteCount++;
      }
      lWordCount = (lByteCount - (lByteCount % 4)) / 4;
      lBytePosition = (lByteCount % 4) * 8;
      lWordArray[lWordCount] = lWordArray[lWordCount] | (0x80 << lBytePosition);
      lWordArray[lNumberOfWords - 2] = lMessageLength << 3;
      lWordArray[lNumberOfWords - 1] = lMessageLength >>> 29;
      return lWordArray;
    };

    function WordToHex(lValue) {
      let WordToHexValue = "",
        WordToHexValue_temp = "",
        lByte, lCount;
      for (lCount = 0; lCount <= 3; lCount++) {
        lByte = (lValue >>> (lCount * 8)) & 255;
        WordToHexValue_temp = "0" + lByte.toString(16);
        WordToHexValue = WordToHexValue + WordToHexValue_temp.substr(WordToHexValue_temp.length - 2, 2);
      }
      return WordToHexValue;
    };

    function Utf8Encode(string) {
      string = string.replace(/\r\n/g, "\n");
      let utftext = "";

      for (let n = 0; n < string.length; n++) {

        let c = string.charCodeAt(n);

        if (c < 128) {
          utftext += String.fromCharCode(c);
        } else if ((c > 127) && (c < 2048)) {
          utftext += String.fromCharCode((c >> 6) | 192);
          utftext += String.fromCharCode((c & 63) | 128);
        } else {
          utftext += String.fromCharCode((c >> 12) | 224);
          utftext += String.fromCharCode(((c >> 6) & 63) | 128);
          utftext += String.fromCharCode((c & 63) | 128);
        }

      }

      return utftext;
    };

    let x = Array();
    let k, AA, BB, CC, DD, a, b, c, d;
    let S11 = 7,
      S12 = 12,
      S13 = 17,
      S14 = 22;
    let S21 = 5,
      S22 = 9,
      S23 = 14,
      S24 = 20;
    let S31 = 4,
      S32 = 11,
      S33 = 16,
      S34 = 23;
    let S41 = 6,
      S42 = 10,
      S43 = 15,
      S44 = 21;

    string = Utf8Encode(string);

    x = ConvertToWordArray(string);

    a = 0x67452301;
    b = 0xEFCDAB89;
    c = 0x98BADCFE;
    d = 0x10325476;

    for (k = 0; k < x.length; k += 16) {
      AA = a;
      BB = b;
      CC = c;
      DD = d;
      a = FF(a, b, c, d, x[k + 0], S11, 0xD76AA478);
      d = FF(d, a, b, c, x[k + 1], S12, 0xE8C7B756);
      c = FF(c, d, a, b, x[k + 2], S13, 0x242070DB);
      b = FF(b, c, d, a, x[k + 3], S14, 0xC1BDCEEE);
      a = FF(a, b, c, d, x[k + 4], S11, 0xF57C0FAF);
      d = FF(d, a, b, c, x[k + 5], S12, 0x4787C62A);
      c = FF(c, d, a, b, x[k + 6], S13, 0xA8304613);
      b = FF(b, c, d, a, x[k + 7], S14, 0xFD469501);
      a = FF(a, b, c, d, x[k + 8], S11, 0x698098D8);
      d = FF(d, a, b, c, x[k + 9], S12, 0x8B44F7AF);
      c = FF(c, d, a, b, x[k + 10], S13, 0xFFFF5BB1);
      b = FF(b, c, d, a, x[k + 11], S14, 0x895CD7BE);
      a = FF(a, b, c, d, x[k + 12], S11, 0x6B901122);
      d = FF(d, a, b, c, x[k + 13], S12, 0xFD987193);
      c = FF(c, d, a, b, x[k + 14], S13, 0xA679438E);
      b = FF(b, c, d, a, x[k + 15], S14, 0x49B40821);
      a = GG(a, b, c, d, x[k + 1], S21, 0xF61E2562);
      d = GG(d, a, b, c, x[k + 6], S22, 0xC040B340);
      c = GG(c, d, a, b, x[k + 11], S23, 0x265E5A51);
      b = GG(b, c, d, a, x[k + 0], S24, 0xE9B6C7AA);
      a = GG(a, b, c, d, x[k + 5], S21, 0xD62F105D);
      d = GG(d, a, b, c, x[k + 10], S22, 0x2441453);
      c = GG(c, d, a, b, x[k + 15], S23, 0xD8A1E681);
      b = GG(b, c, d, a, x[k + 4], S24, 0xE7D3FBC8);
      a = GG(a, b, c, d, x[k + 9], S21, 0x21E1CDE6);
      d = GG(d, a, b, c, x[k + 14], S22, 0xC33707D6);
      c = GG(c, d, a, b, x[k + 3], S23, 0xF4D50D87);
      b = GG(b, c, d, a, x[k + 8], S24, 0x455A14ED);
      a = GG(a, b, c, d, x[k + 13], S21, 0xA9E3E905);
      d = GG(d, a, b, c, x[k + 2], S22, 0xFCEFA3F8);
      c = GG(c, d, a, b, x[k + 7], S23, 0x676F02D9);
      b = GG(b, c, d, a, x[k + 12], S24, 0x8D2A4C8A);
      a = HH(a, b, c, d, x[k + 5], S31, 0xFFFA3942);
      d = HH(d, a, b, c, x[k + 8], S32, 0x8771F681);
      c = HH(c, d, a, b, x[k + 11], S33, 0x6D9D6122);
      b = HH(b, c, d, a, x[k + 14], S34, 0xFDE5380C);
      a = HH(a, b, c, d, x[k + 1], S31, 0xA4BEEA44);
      d = HH(d, a, b, c, x[k + 4], S32, 0x4BDECFA9);
      c = HH(c, d, a, b, x[k + 7], S33, 0xF6BB4B60);
      b = HH(b, c, d, a, x[k + 10], S34, 0xBEBFBC70);
      a = HH(a, b, c, d, x[k + 13], S31, 0x289B7EC6);
      d = HH(d, a, b, c, x[k + 0], S32, 0xEAA127FA);
      c = HH(c, d, a, b, x[k + 3], S33, 0xD4EF3085);
      b = HH(b, c, d, a, x[k + 6], S34, 0x4881D05);
      a = HH(a, b, c, d, x[k + 9], S31, 0xD9D4D039);
      d = HH(d, a, b, c, x[k + 12], S32, 0xE6DB99E5);
      c = HH(c, d, a, b, x[k + 15], S33, 0x1FA27CF8);
      b = HH(b, c, d, a, x[k + 2], S34, 0xC4AC5665);
      a = II(a, b, c, d, x[k + 0], S41, 0xF4292244);
      d = II(d, a, b, c, x[k + 7], S42, 0x432AFF97);
      c = II(c, d, a, b, x[k + 14], S43, 0xAB9423A7);
      b = II(b, c, d, a, x[k + 5], S44, 0xFC93A039);
      a = II(a, b, c, d, x[k + 12], S41, 0x655B59C3);
      d = II(d, a, b, c, x[k + 3], S42, 0x8F0CCC92);
      c = II(c, d, a, b, x[k + 10], S43, 0xFFEFF47D);
      b = II(b, c, d, a, x[k + 1], S44, 0x85845DD1);
      a = II(a, b, c, d, x[k + 8], S41, 0x6FA87E4F);
      d = II(d, a, b, c, x[k + 15], S42, 0xFE2CE6E0);
      c = II(c, d, a, b, x[k + 6], S43, 0xA3014314);
      b = II(b, c, d, a, x[k + 13], S44, 0x4E0811A1);
      a = II(a, b, c, d, x[k + 4], S41, 0xF7537E82);
      d = II(d, a, b, c, x[k + 11], S42, 0xBD3AF235);
      c = II(c, d, a, b, x[k + 2], S43, 0x2AD7D2BB);
      b = II(b, c, d, a, x[k + 9], S44, 0xEB86D391);
      a = AddUnsigned(a, AA);
      b = AddUnsigned(b, BB);
      c = AddUnsigned(c, CC);
      d = AddUnsigned(d, DD);
    }

    let temp = WordToHex(a) + WordToHex(b) + WordToHex(c) + WordToHex(d);

    return temp.toLowerCase();
  }
}



// WEBPACK FOOTER //
// ./src/pages/params.ts